import React from "react";
import Tooltip from "../Tooltip";
import Chips from "../Chips";

import { IKeyNumberDict, ILanguageType } from "@/types/GlobalTypes";
import { getCSSSize } from "@/modules/commonMobile";

interface IProps {
    //Dynamic props
    keyPattern: string[][];

    firstLeftPercent: number;
    firstTopPercent: number;

    leftSpace: string;
    topSpace: string;

    width: number;
    height: number;

    betGroup: string;

    //Static props
    chipBase: number[];
    pcode: string;
    bets: IKeyNumberDict;
    betOutOfBounds: {[key: string]: boolean};
    langdata: ILanguageType;
    
    mobile?: boolean;
    noTooltip?: boolean;

    showBorders?: boolean;

    insertBet: (e: any) => void;
    mouseOver: (e: any) => void;
    mouseLeave: (e: any) => void;
}

export default class MultibetGenerator extends React.Component<IProps> {
    render() {
        const {
            keyPattern,
            langdata,

            firstLeftPercent,
            leftSpace,

            firstTopPercent,
            topSpace,

            width,
            height,

            betGroup,
            betOutOfBounds,

            showBorders
        } = this.props;

        const commonTooltipProps = {
			langStr: langdata.language_code
        };
        
        const leftSpaceAry = getCSSSize(leftSpace);
        const topSpaceAry = getCSSSize(topSpace);

        // console.log("tS", topSpace);
        // console.log("tSA", topSpaceAry);


        return (
            keyPattern.map((row, rowIdx) => 
                row.map((groupComma, groupIdx) => {
                    return <div key={this.props.pcode + "_" + betGroup + "_" + rowIdx + "_" + groupIdx}
                            className={"sl-bet sl-green-old" + (!showBorders ? " hidden" : "")}
                            style={{position: "absolute",

                                left: "calc(" +
                                    firstLeftPercent + "% + " +
                                    (groupIdx * +leftSpaceAry[0]) + leftSpaceAry[1] + " - " +
                                    (width / 2) + "px)",

                                top: "calc(" +
                                    firstTopPercent + "% + " +
                                    (rowIdx * +topSpaceAry[0]) + topSpaceAry[1] + " - " +
                                    (height / 2) + "px)",

                                background: "transparent",
                                width: width,
                                height: height}}>

                        <Chips mobile={this.props.mobile}
                            between={true}
                            chipBase={this.props.chipBase}
                            bets={this.props.bets}
                            betOutOfBounds={betOutOfBounds}
                            betKey={groupComma + "+" + betGroup} />

                    {
                        this.props.noTooltip ? null :
                            <Tooltip
                                {...commonTooltipProps}
                                bet={this.props.bets[groupComma + "+" + betGroup]} />
                    }

                        <div className="sl-hover-hidden"
                        {...{
                            bet: groupComma,
                            group: betGroup,
                            pcode: this.props.pcode
                        }}
                            onClick={this.props.insertBet}
                            onMouseLeave={this.props.mouseLeave}
                            onMouseOver={this.props.mouseOver} />
                    </div>;
                })
            )
        );
    }
}